import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  navigationStep: {
    marginTop: 18,
    marginBottom: 18,
    display: "flex",
    justifyContent: "space-between",
  },
  firstNavigationStep: {
    marginTop: 18,
    display: "flex",
    justifyContent: "flex-end",
  },
  textButton: {
    backgroundColor: "transparent !important",
    border: "1px solid rgba(0, 0, 0, 0.23) !important",
    color: "black !important",
    "&:hover": {
      backgroundColor: `${theme.color.gray1} !important`, // light gray hover
    },
    "&:focus": {
      backgroundColor: `${theme.color.gray1} !important`,
    },
    // Disabled state styling
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      border: "1px solid rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
      cursor: "not-allowed !important",
    },
  },
  // Loading state for buttons
  loadingButton: {
    position: "relative",
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      border: "1px solid rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
      cursor: "progress !important",
    },
  },
  // Spinner container
  buttonContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    marginRight: "8px !important",
  },
  // Disabled navigation buttons
  disabledNavButton: {
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      borderColor: "rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
      cursor: "not-allowed !important",
    },
  },
  // Primary button disabled state
  disabledPrimaryButton: {
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
      cursor: "not-allowed !important",
    },
  },
}));
